import { StyleSheet } from 'aphrodite';
import { borderColor, inputBorderColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		padding: '12px 0',
	},
	filterRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 12,
		alignItems: 'flex-end',
	},
	filterField: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		minWidth: 140,
		flex: '0 1 160px',
	},
	label: {
		fontSize: 12,
		fontWeight: 600,
		color: '#4A4A4A',
	},
	input: {
		border: `1px solid ${inputBorderColor}`,
		borderRadius: 4,
		fontSize: 13,
		height: 32,
		padding: '0 8px',
		width: '100%',
		boxSizing: 'border-box',
	},
	heading: {
		color: '#0D0F11',
		fontSize: 16,
		fontWeight: 400,
		margin: 0,
	},
	expandHint: {
		color: '#0D0F11',
		fontSize: 11,
		fontWeight: 400,
		marginLeft: 8,
	},
	clearButton: {
		background: 'none',
		border: 'none',
		color: '#0070c9',
		cursor: 'pointer',
		fontSize: 12,
		padding: 0,
		':hover': {
			textDecoration: 'underline',
		},
	},
	headerRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	expandToggle: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		gap: 6,
		padding: 0,
	},
	expandIcon: {
		height: 10,
		transition: 'transform 0.2s ease',
		width: 10,
	},
	expandIconOpen: {
		transform: 'rotate(90deg)',
	},
	filterBadge: {
		background: 'rgba(248, 145, 67, 0.7)',
		borderRadius: 10,
		color: '#fff',
		display: 'inline-block',
		fontSize: 10,
		fontWeight: 700,
		lineHeight: '16px',
		marginLeft: 6,
		minWidth: 16,
		padding: '0 5px',
		textAlign: 'center',
	},
	// Dropdown styles matching policy board pattern
	dropdownAnchor: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: 13,
		minWidth: 180,
		padding: 10,
	},
	dropdownIcon: {
		transform: 'rotate(90deg)',
	},
	dropdownInline: {
		borderColor: inputBorderColor,
		borderRadius: 8,
		borderStyle: 'solid',
		borderWidth: 1,
		boxSizing: 'border-box',
		maxWidth: 600,
		overflowY: 'visible',
	},
	dropdownInlineOpen: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
	dropdownMenu: {
		background: '#fff',
		marginTop: 2,
		minWidth: '300px !important',
		display: 'flex',
		flexDirection: 'column',
		left: '-1px !important',
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		borderTopRightRadius: 0,
	},
	dropdownContentInner: {
		borderColor: inputBorderColor,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		borderTopRightRadius: 0,
		maxHeight: 350,
		overflowY: 'auto',
	},
	dropdownContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		padding: 16,
	},
	dropdownRow: {
		display: 'flex',
		gap: 8,
		fontSize: 12,
		padding: 4,
	},
	categoryRow: {
		fontWeight: 600,
	},
	categoryLabel: {
		fontWeight: 600,
	},
	nestedRow: {
		paddingLeft: 24,
	},
	dropdownSeparator: {
		borderBottom: `1px solid ${borderColor}`,
	},
	resetButton: {
		background: 'none',
		border: 'none',
		color: '#0070c9',
		cursor: 'pointer',
		fontSize: 12,
		padding: 4,
		textAlign: 'left',
		':hover': {
			textDecoration: 'underline',
		},
	},
});
